export enum WeightType {
    kg = "kg"
}